<template>
  <v-data-table
    :headers="headers"
    :items="users"
    sort-by="username"
    :search="search"
    class="elevation-1"
    v-model="selected"
    item-key="username"
    multi-sort
    :loading="loading"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-text-field
          flat
          solo
          prepend-icon="search"
          placeholder="Search"
          v-model="search"
          hide-details
          class="hidden-sm-and-down"
        ></v-text-field>

        <v-spacer></v-spacer>

        <v-bottom-sheet v-model="sheet">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              class="mb-2"
              v-bind="attrs"
              v-on="on"
              @click="clearSheet"
              v-if="checkRole('lf')"
            >
              New User
            </v-btn>
          </template>

          <v-card>
            <v-tabs
              centered
              fixed-tabs
              background-color="cyan"
              dark
              icons-and-text
              v-model="tab"
            >
              <v-spacer></v-spacer>

              <v-tabs-slider color="yellow"></v-tabs-slider>
              <v-tab href="#tab-1">
                Profile
                <v-icon>mdi-badge-account-horizontal-outline</v-icon>
              </v-tab>

              <!-- <v-tab href="#tab-2">
                Settings
                <v-icon>mdi-cog-outline</v-icon>
              </v-tab> -->

              <v-spacer></v-spacer>

              <v-btn
                class="align-self-center mr-4"
                icon
                dark
                fab
                @click="editMode = !editMode"
                v-if="!editMode && checkRole(['lf', 'ROLE_DEALERADMIN'])"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              
              <v-btn
                class="align-self-center mr-4"
                icon
                dark
                fab
                @click="editMode = !editMode"
                v-if="editMode"
              >
                <v-icon>mdi-pencil-off</v-icon>
              </v-btn>

              <v-btn
                class="align-self-center mr-4"
                icon
                dark
                fab
                @click="close()"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>

              <v-tab-item :key="1" :value="'tab-1'">
                <v-card flat>
                  <v-form ref="form">
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="6">
                          <v-text-field
                            v-model="editedItem.fullName"
                            label="Name"
                            name="name"
                            :rules="rules.required"
                            required
                            hint="Required"
                            persistent-hint
                            color="cyan"
                            :readonly="!editMode"
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="6">
                          <v-text-field
                            v-model="editedItem.username"
                            name="username"
                            label="Username"
                            :rules="rules.username"
                            required
                            hint="Required"
                            persistent-hint
                            color="cyan"
                            :readonly="!editMode"
                          ></v-text-field>
                        </v-col>
                        
                        <v-col cols="12" sm="6">
                          <div class="text-center">
                            <v-text-field
                              v-model="editedItem.password"
                              name="password"
                              label="Password"
                              :rules="rules.password"
                              required
                              hint="Required"
                              persistent-hint
                              :type="show ? 'text' : 'password'"
                              :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                              @click:append="show = !show"
                              color="cyan"
                              :readonly="!editMode"
                              v-if="showPasswordField"
                            ></v-text-field>
                            <v-btn
                              outlined
                              large
                              color="cyan"
                              v-else
                              @click="resetPassword()"
                              v-show="editMode"
                            >
                              <v-icon
                                left
                                dark
                              >
                                mdi-lock-reset
                              </v-icon>
                              Reset Password
                            </v-btn>
                          </div>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col
                          cols="12"
                          sm="6"
                          v-if="checkRole('lf')"
                          :disabled="checkRole('ROLE_LFTECH') || checkRole('ROLE_LFBILLING')"
                        >
                          <v-autocomplete
                            v-model="editedItem.role"
                            label="Role"
                            name="role"
                            :items="roles"
                            item-text="role"
                            item-value="value"
                            :rules="rules.required"
                            required
                            hint="Required"
                            persistent-hint
                            color="cyan"
                            item-color="cyan"
                            @change="rolePush(editedItem.role)"
                            :readonly="!editMode"
                          ></v-autocomplete>
                        </v-col>

                        <v-col
                          cols="12"
                          sm="6"
                          v-else
                          :disabled="checkRole('ROLE_DEALERTECH') || checkRole('ROLE_CLIENT')"
                        >
                          <v-autocomplete
                            v-model="editedItem.role"
                            label="Role"
                            name="role"
                            :items="rolesDealers"
                            item-text="role"
                            item-value="value"
                            :rules="rules.required"
                            required
                            hint="Required"
                            persistent-hint
                            color="cyan"
                            item-color="cyan"
                            @change="rolePush(editedItem.role)"
                            :readonly="!editMode"
                          ></v-autocomplete>
                        </v-col>

                        <v-col
                          cols="12"
                          sm="6"
                          v-if="checkRole('lf')"
                          :disabled="checkRole('ROLE_LFTECH') || checkRole('ROLE_LFBILLING')"
                        >
                          <v-autocomplete
                            v-model="editedItem.customerID"
                            label="Company"
                            name="company"
                            :items="customers"
                            item-text="customerName"
                            item-value="customerID"
                            :rules="rules.required"
                            required
                            hint="Required"
                            persistent-hint
                            color="cyan"
                            item-color="cyan"
                            :readonly="!editMode"
                          ></v-autocomplete>
                        </v-col>

                        <v-col
                          cols="12"
                          sm="6"
                          v-if="checkRole('ROLE_DEALERADMIN') && editedItem.role == 'client'"
                        >
                          <v-autocomplete
                            v-model="editedItem.customerID"
                            label="Company"
                            name="company"
                            :items="customers"
                            item-text="customerName"
                            item-value="customerID"
                            :rules="rules.required"
                            required
                            hint="Required"
                            persistent-hint
                            color="cyan"
                            item-color="cyan"
                            :readonly="!editMode"
                          ></v-autocomplete>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="6">
                          <v-text-field
                            v-model="editedItem.email"
                            label="E-mail"
                            name="email"
                            :rules="rules.email"
                            required
                            hint="Required"
                            persistent-hint
                            color="cyan"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6">
                          <v-text-field
                            v-model="editedItem.phone"
                            label="Phone"
                            color="cyan"
                            :readonly="!editMode"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>

                    <v-container>
                      <v-card-actions v-if="checkRole(['lf', 'ROLE_DEALERADMIN'])">
                        <v-spacer></v-spacer>
                        <v-btn
                          plain
                          @click="close"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          color="cyan"
                          dark
                          @click="save"
                        >
                          Save
                        </v-btn>
                      </v-card-actions>
                    </v-container>
                  </v-form>
                </v-card>
              </v-tab-item>

              <!-- <v-tab-item :key="2" :value="'tab-2'">
                <v-card flat>
                  <v-form clearable>
                    <v-container>
                      <v-row dense>
                        <v-col
                          cols="12"
                          sm="12"
                        >
                        <v-switch
                          v-model="editedItem.metric"
                          label="Metric"
                          color="cyan"
                        ></v-switch>
                        </v-col>
                      </v-row>

                      <v-row dense>
                        <v-col
                          cols="12"
                          sm="6"
                        >
                          <v-autocomplete
                            v-model="editedItem.timezone"
                            :items="timezones"
                            label="Timezone"
                            item-text="text"
                            item-value="abbr"
                            color="cyan"
                            item-color="cyan"
                            ></v-autocomplete>
                        </v-col>
                      </v-row>
                    </v-container>

                    <v-container>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          plain
                          @click="close"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          color="cyan"
                          dark
                          @click="save"
                        >
                          Save
                        </v-btn>
                      </v-card-actions>
                    </v-container>
                  </v-form>
                </v-card>
              </v-tab-item> -->
            </v-tabs>
          </v-card>
        </v-bottom-sheet>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="headline">Are you sure you want to delete this item?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="closeDelete">Cancel</v-btn>
              <v-btn color="error" dark @click="deleteItemConfirm">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogResetPassword" max-width="500px">
          <v-card>
            <v-card-title class="headline">Are you sure you want to reset this user's password?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="dialogResetPassword = false">Cancel</v-btn>
              <v-btn color="cyan" dark @click="resetPasswordConfirm">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-divider></v-divider>
    </template>

    <template v-slot:item.username="props">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <span
            class="subtitle-1"
            style="border-bottom: 1px dashed #111; cursor: pointer;"
            @click="editItem(props.item)"
            v-bind="attrs"
            v-on="on"
          >
            {{ props.item.username }}
          </span>
        </template>
        <span>View User</span>
      </v-tooltip>

      <v-tooltip top v-if="checkRole('lf')">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="ml-2"
            icon
            v-bind="attrs"
            v-on="on"
            @click="$router.push(`dealers?customername=${props.item.customer.customerName}`)"
          >
            <v-icon>
              mdi-location-enter
            </v-icon>
          </v-btn>
        </template>
        <span>Go to Company</span>
      </v-tooltip>
    </template>

    <template v-slot:item.roles[0].roleName="props">
      {{ convertRoleName(props.item.roles[0].roleName) }}
    </template>

    <template v-slot:item.actions="{ item }">
      <v-menu offset-y transition="slide-y-transition">
        <template v-slot:activator="{ on: menu, attrs }">
          <v-tooltip top>
            <template v-slot:activator="{ on: tooltip }">
              <v-btn
                color="black"
                icon
                v-bind="attrs"
                v-on="{ ...tooltip, ...menu }"
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <span>Actions</span>
          </v-tooltip>
        </template>
        <v-list>
          <v-list-item
            v-if="checkRole('lf')"
            @click="$router.push(`dealers?customername=${item.customer.customerName}`)"
          >
            <v-list-item-action class="mr-4">
              <v-icon color="">mdi-domain</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Company</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="editItem(item)">
            <v-list-item-action class="mr-4">
              <v-icon>mdi-magnify</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>View</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>

    <template v-slot:no-data>
      <v-btn
        color="primary"
        @click="initialize"
      >
        Reset
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
  import AuthService from "../../../services/auth.service"
  import CustomerService from "../../../services/customer.service"
  import Timezones from "../../../api/timezone.js"
  import Roles from "../../../api/role.js"
  import RolesDealers from "../../../api/roledealer.js"

  export default {
    data: () => ({
      search: '',
      message: '',
      selected: [],
      loading: false,
      sheet: false,
      tab: null,
      dialog: false,
      dialogDelete: false,
      showPasswordField: false,
      dialogResetPassword: false,
      headers: [
        { text: "Username", align: "start", value: "username" },
        { text: "Name", value: "fullName" },
        { text: "Company", value: "customer.customerName" },
        { text: "Role", value: "roles[0].roleName" },
        { text: "Email", value: "email" },
        { text: "Phone", value: "phone" },
        { text: "Actions", value: "actions", align: "center", sortable: false }
      ],
      show: false,
      rules: {
        required: [
          value => !!value || 'Required',
        ],
        username: [
          v => !!v || 'Required',
          v => (v && !v.includes(' ')) || 'Spaces not allowed',
        ],
        password: [
          v => !!v || 'Required',
          v => (v && v.length >= 8) || 'Must have at least 8 characters',
          v => /(?=.*[A-Z])/.test(v) || 'Must have at least one uppercase character',
          v => /(?=.*\d)/.test(v) || 'Must have at least one number',
          v => /([!&@#$%])/.test(v) || 'Must have at least one special character (!&@#$%)'
        ],
        email: [
          v => !!v || 'Required',
          v => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'Invalid email',
        ],
      },
      users: [],
      role:[],
      customers: [],
      editedIndex: -1,
      editedItem: {
        fullName: '',
        username: '',
      },
      defaultItem: {
        fullName: '',
        username: '',
      },
      timezones: Timezones,
      roles: Roles,
      rolesDealers: RolesDealers,
      editMode: false,
    }),

    computed: {
      currentUser() {
        return this.$store.state.auth.user;
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },

      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize() {
        this.checkAuth()
        this.retrieveUsers()
        this.retrieveCustomers()
      },

      checkAuth() {
        if (!this.$route.meta.authorize.includes(this.currentUser.roles.toString())) {
          this.$router.push('/dashboard')
        }
      },

      checkRole(role) {
        if (Array.isArray(role)) {
          var i
          for (i = 0; i < role.length; i++) {
            if (this.currentUser.roles.includes(role[i])) {
              return true
            }
            if (role[i] == 'lf') {
              if (this.currentUser.roles.includes('ROLE_LFADMIN') || this.currentUser.roles.includes('ROLE_LFTECH') || this.currentUser.roles.includes('ROLE_LFBILLING')) {
                return true
              }
            }
            if (role[i] == 'dealer') {
              if (this.currentUser.roles.includes('ROLE_DEALERADMIN') || this.currentUser.roles.includes('ROLE_DEALERTECH')) {
                return true
              }
            }
          }
          return false
        }

        if (role == 'lf') {
          if (this.currentUser.roles.includes('ROLE_LFADMIN') || this.currentUser.roles.includes('ROLE_LFTECH') || this.currentUser.roles.includes('ROLE_LFBILLING')) {
            return true
          }
        }

        if (role == 'dealer') {
          if (this.currentUser.roles.includes('ROLE_DEALERADMIN') || this.currentUser.roles.includes('ROLE_DEALERTECH')) {
            return true
          }
        }

        if (this.currentUser.roles.includes(role)) {
          return true
        } else {
          return false
        }
      },

      async retrieveUsers() {
        this.loading = true
        if (this.$route.query.customerid) {
          await AuthService.getCustomerUsers(this.$route.query.customerid)
            .then(response => {
              this.users = response.data || []
              var _this = this
              this.users.forEach(forEachUser)

              function forEachUser(item, index) {
                _this.users[index].role = item.roles[0].roleName
              }

              return new Promise(resolve => {
                resolve('Done')
              })
            })
            .catch(e => {
              console.log(e);
              window._LOL2P.$emit('SHOW_SNACKBAR', {
                text: 'There was an error retrieving users',
                color: 'error'
              })
            });
        } else {
          if (!this.checkRole('lf')) {
            await AuthService.getCustomerUsers(this.currentUser.customerID)
              .then(response => {
                this.users = response.data || []
                var _this = this
                this.users.forEach(forEachUser)

                function forEachUser(item, index) {
                  _this.users[index].role = item.roles[0].roleName
                }

                return new Promise(resolve => {
                  resolve('Done')
                })
              })
              .catch(e => {
                console.log(e);
                window._LOL2P.$emit('SHOW_SNACKBAR', {
                  text: 'There was an error retrieving users',
                  color: 'error'
                })
              });
          } else {
            await AuthService.getAll()
              .then(response => {
                this.users = response.data || []
                var _this = this
                this.users.forEach(forEachUser)

                function forEachUser(item, index) {
                  _this.users[index].role = item.roles[0].roleName
                }

                return new Promise(resolve => {
                  resolve('Done')
                })
              })
              .catch(e => {
                console.log(e);
                window._LOL2P.$emit('SHOW_SNACKBAR', {
                  text: 'There was an error retrieving users',
                  color: 'error'
                })
              });
          }
        }

        this.loading = false
      },

      createUser() {
        if (!this.checkRole('lf')) {
          if (this.$route.query.customerid) {
            this.editedItem.customerID = this.$route.query.customerid;
          } else {
            this.editedItem.customerID = this.$store.state.auth.user.customerID;
          }
        }
        AuthService.register(this.editedItem)
          .then(response => {
            this.snackbar('Success! The user was created successfully','success')
            this.users.push(this.editedItem)
          })
          .catch(e => {
            console.log(e);
            if (e.response && e.response.status === 400) {
              this.snackbar(e.response.data.message, 'error')
            } else {
              this.snackbar('Error! There was an error creating the user', 'error')
            }
          })
      },

      updateUser() {
        AuthService.update(this.editedItem.userID, this.editedItem)
          .then(response => {
            window._LOL2P.$emit('SHOW_SNACKBAR', {
              text: 'The user was updated successfully',
              color: 'success'
            })
          })
          .catch(e => {
            console.log(e);
            window._LOL2P.$emit('SHOW_SNACKBAR', {
              text: 'There was an error updating the user',
              color: 'error'
            })
          });
      },

      deleteUser() {
        AuthService.delete(this.editedItem.userID)
          .then(response => {
            window._LOL2P.$emit('SHOW_SNACKBAR', {
              text: 'The user was deleted successfully',
              color: 'success'
            })
          })
          .catch(e => {
            console.log(e);
            window._LOL2P.$emit('SHOW_SNACKBAR', {
              text: 'There was an error deleting the user',
              color: 'error'
            })
          });
      },

      retrieveCustomers() {
        if (this.checkRole('lf')) {
          CustomerService.getAll()
          .then(response => {
            this.customers = response.data || []
          })
          .catch(e => {
            console.log(e);
          });
        } else if (this.checkRole('ROLE_DEALERADMIN')) {
          CustomerService.getDealerClients(this.currentUser.customerID)
            .then(response => {
              this.customers = response.data || []
            })
            .catch(e => {
              console.log(e);
            });
        }
      },

      retrieveDealers() {
        if (this.checkRole('lf')) {
          CustomerService.getDealers()
          .then(response => {
            this.customers = response.data || []
          })
          .catch(e => {
            console.log(e);
          });
        }
      },

      retrieveClients() {
        if (this.checkRole('lf')) {
          CustomerService.getClients()
          .then(response => {
            this.customers = response.data || []
          })
          .catch(e => {
            console.log(e);
          });
        } else if (this.checkRole('ROLE_DEALERADMIN')) {
          CustomerService.getDealerClients(this.currentUser.customerID)
            .then(response => {
              this.customers = response.data || []
            })
            .catch(e => {
              console.log(e);
            });
        }
      },

      resetPassword() {
        this.dialogResetPassword = true
      },

      resetPasswordConfirm() {
        this.editedItem.password = ""
        this.editedItem.resetPassword = true
        this.showPasswordField = true
        this.dialogResetPassword = false
      },

      rolePush(role) {
        this.role = []
        if (!this.editedItem.roles) {
          this.editedItem.roles = []
          this.editedItem.roles[0] = {
            "roleName": null
          }
        }

        this.role.push(role)
        this.editedItem.roles[0].roleName = role

        if (role.substring(0, 6) == 'client') {
          this.retrieveClients()
        } else if (role.substring(0, 6) == 'dealer') {
          if (this.checkRole('lf')) {
            this.retrieveDealers()
          } else {
            this.editedItem.customerID = this.currentUser.customerID
          }
        }
      },

      routerPush(customerID) {
        if (this.isDealer(customerID)) {
          this.$router.push('/companies/clients?dealerid=' + customerID);
        } else {
          this.$router.push('/companies/locations?customerid=' + customerID);
        }
      },

      isDealer() {

      },

      clearSheet() {
        this.editMode = true
        this.close()
        this.editedItem.fullName = ""
        this.editedItem.username = ""
        this.editedItem.password = ""
        this.editedItem.companyID = null
        this.editedItem.roles = []
        this.editedItem.role = ""
        this.editedItem.email = ""
        this.editedItem.phone = ""
        this.editedItem.metric = 0
        this.editedItem.timezone = ""
        this.editedItem.resetPassword = ""
        this.editedIndex = -1
        this.showPasswordField = true
        this.tab = 1
      },

      editItem(item) {
        this.editMode = false
        this.editedIndex = this.users.indexOf(item)
        this.editedItem = Object.assign({}, item)
        if(this.editedIndex > -1) {
          this.showPasswordField = false
        } else {
          this.showPasswordField = true
        }
        this.sheet = true
      },

      deleteItem(item) {
        this.editedIndex = this.users.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm() {
        this.users.splice(this.editedIndex, 1)
        this.deleteUser();
        this.closeDelete()
      },

      close() {
        this.sheet = false
        if (this.$route.query.customerid) {
          this.defaultItem.customerID = this.$route.query.customerid
        }
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete() {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save() {
        if (!this.$refs.form.validate()) {
          this.snackbar('Error! Missing user information', 'error', '3000')
          return
        }

        if (this.editedIndex > -1) {
          this.updateUser()
          Object.assign(this.users[this.editedIndex], this.editedItem)
        } else {
          this.createUser()
        }
        this.close()
      },

      convertRoleName(roleName) {
        if (roleName == 'lfadmin') {
          return 'LF Admin'
        } else if (roleName == 'lftech') {
          return 'LF Tech'
        } else if (roleName == 'lfbilling') {
          return 'LF Billing'
        } else if (roleName == 'dealeradmin') {
          return 'Admin'
        } else if (roleName == 'dealertech') {
          return 'Tech'
        } else if (roleName == 'client') {
          return 'Client'
        }
      },

      snackbar(message, color, timeout) {
        window._LOL2P.$emit('SHOW_SNACKBAR', {
          text: message,
          color: color,
          timeout: timeout
        })
      },
    },
  }
</script>